import React from 'react';
import PrivacyContent from '../components/PrivacyContent';

const PrivacyPolicy = () => {
  return (
    <PrivacyContent />
  );
};

export default PrivacyPolicy;
